import { useEffect, useMemo } from "react"
import { useMsal } from "@azure/msal-react"
import { bindProactiveTokenRefresh, unbindProactiveTokenRefresh } from "@/utils/accessToken"

/** Keeps the MSAL ID token fresh before expiry while the user is signed in. */
const ProactiveTokenRefresh = (): null => {
    const { accounts } = useMsal()

    const accountKey = useMemo(() => accounts[0]?.homeAccountId ?? accounts[0]?.localAccountId ?? "", [accounts])

    useEffect(() => {
        if (!accountKey) {
            unbindProactiveTokenRefresh()
            return
        }

        bindProactiveTokenRefresh()
        return () => unbindProactiveTokenRefresh()
    }, [accountKey])

    return null
}

export default ProactiveTokenRefresh
